import { useState } from 'react';
import './AdminPartsListView.scss';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface AdminPartsListViewProps {
  partsList: any[];
  onSelectPart: (part: any, viewType: 'results' | 'edit') => void;
  onDownload: (part: any) => void;
  onOrder: (part: any) => void;
  itemsPerPage: number;
  getStatus: (processed: any) => string;
  loggedInUser?: string;
  noResultFoundImg: string;
  onUploadDesign: () => void;
  isAdmin?: boolean;
}

const AdminPartsListView = ({ partsList, onSelectPart, onDownload, onOrder, itemsPerPage, getStatus, loggedInUser, noResultFoundImg, onUploadDesign, isAdmin }: AdminPartsListViewProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [compactView, setCompactView] = useState(false);

  // Pagination
  const totalPages = Math.ceil(partsList.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentParts = partsList.slice(startIndex, endIndex);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'short', 
      year: 'numeric', 
      month: 'short', 
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="admin-parts-list-view">
      {partsList.length === 0 ? (
        <div className="empty-state">
          <img src={noResultFoundImg} alt="No results found" style={{ maxWidth: '300px', marginBottom: '20px' }} />
          <p>No Data available.</p>
          <p> Click here to <a href="#" onClick={(e) => { e.preventDefault(); onUploadDesign(); }} style={{ color: '#FF6B35', textDecoration: 'underline', cursor: 'pointer' }}>Upload Design</a> </p>
        </div>
      ) : (
        <>
          {/* Table Section */}
          <div className={`table-container ${compactView ? 'compact' : ''}`}>
        <table className="parts-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Part Name</th>
              {isAdmin && <th>Owned by</th>}
              <th>Model Type</th>
              <th>Created At</th>
              <th>Updated At</th>
              
              <th style={{ width: '400px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentParts.map((part, index) => {
              const isDisabled = !part.Processed || 
                                 Object.keys(part.Processed).length === 0 || 
                                 Object.values(part.Processed).includes('False');
              
              return (
                <tr key={part.PartID}>
                  <td>{startIndex + index + 1}</td>
                  <td className="part-name">{part.PartName}</td>
                  {isAdmin && <td>{loggedInUser || part.Username || 'N/A'}</td>}
                  <td>{part.ModelType}</td>
                  <td>{formatDate(part.CreatedAt)}</td>
                  <td>{formatDate(part.UpdatedAt)}</td>
                  
                  <td className="action-buttons">
                    
                        <button 
                          className={`action-btn edit-btn ${isDisabled ? 'disabled' : ''}`}
                          onClick={() => !isDisabled && onSelectPart(part, 'edit')}
                          disabled={isDisabled}
                          title="Edit"
                        >
                          <VisibilityIcon sx={{ width: '20px!important', height: '20px!important' }} /> Estimate
                        </button>

                        
                     
                    
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination Section */}
      <div className="pagination-section">
        <div className="pagination-info">
          Showing {startIndex + 1} to {Math.min(endIndex, partsList.length)} of {partsList.length} entries
        </div>
        <div className="pagination-controls">
          <button 
            className="page-btn"
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (currentPage <= 3) {
              pageNum = i + 1;
            } else if (currentPage >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = currentPage - 2 + i;
            }
            
            return (
              <button
                key={pageNum}
                className={`page-btn ${currentPage === pageNum ? 'active' : ''}`}
                onClick={() => setCurrentPage(pageNum)}
              >
                {pageNum}
              </button>
            );
          })}

          <button 
            className="page-btn"
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
        </>
      )}
    </div>
  );
};

export default AdminPartsListView;
